<template>
  <div class="findspace-account-container">
    <div class="account-title">Accounts</div>
    <div class="findspace-nav-container">
      <div class="tabbed-nav-container">
        <div class="tabbed-nav" :class="{active: activeNav == 'profile'}" @click="activeNav = 'profile'">Profile</div>
        <div class="tabbed-nav" :class="{active: activeNav == 'payment'}" @click="activeNav = 'payment'">Payment Details</div>
      </div>
    </div>
    <div class="findspace-account-content">
      <AccountProfile v-show="activeNav == 'profile'" />
      <AccountPayment v-show="activeNav == 'payment'" ref="paymentDetails" v-if="userType == 'hirer'"/>
      <ListerAccountPayment v-show="activeNav == 'payment'" ref="paymentDetails" v-if="userType == 'lister'"/>
    </div>
  </div>
</template>

<script>
import AccountProfile from './Profile'
import AccountPayment from './Payment'
import ListerAccountPayment from './ListerAccountPayment.vue'

export default {
  components: {
    AccountProfile,
    AccountPayment,
    ListerAccountPayment
  },
  data() {
    return {
      activeNav: 'profile'
    }
  },
  mounted () {
    this.$refs.paymentDetails.loadPaymentMethods()
  },
  computed: {
    userType() {
      return this.$store.getters['findspace/userType']
    }
  }
}
</script>
